import React, { useState, useCallback } from 'react';
import { Grid, Box, Tabs, Tab } from '@mui/material';
import { useSelector } from 'react-redux';

import DetailTemplate from '../../components/common/template/DetailTemplate';
import DashboardTemplate from '../../components/dashboard/DashboardTemplate';
import DashboardApprovalContainer from './approval/DashboardApprovalContainer';
import DashboardCalendarContainer from './calendar/DashboardCalendarContainer';
import NoticeTemplate from '../../components/dashboard/notice/NoticeTemplate';
import SalesActivityContainer from '../salesActivity/SalesActivityContainer';
import TechActivityContainer from '../techActivity/TechActivityContainer';

// 💡 탭 콘텐츠를 깔끔하게 분리하여 보여주기 위한 패널 컴포넌트 추가
function CustomTabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`dashboard-tabpanel-${index}`}
      aria-labelledby={`dashboard-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ p: 0 }}>
          {children}
        </Box>
      )}
    </div>
  );
}

const DashboardContainer = () => {
  const [calFullTyp, setCalFullTyp] = useState(false);
  const [appLineToggle, setAppLineToggle] = useState(false);
  const { user } = useSelector(({ auth }) => ({
    user: auth.user, //user정보
  }));

  const handleAppLineToggle = () => {
    setAppLineToggle(!appLineToggle);
  };

  const [isCalFull, setIsCalFull] = useState(false);

  // 🚀 2. 안쪽 버튼을 눌렀을 때 상태를 스위칭해 줄 함수 정의 (축소 시 전체 리렌더링 유도)
  const toggleCalFull = () => {
    setIsCalFull(prev => !prev);
  };

  // 💡 상단 탭 상태 관리를 위한 state
  const [tabValue, setTabValue] = useState(0);

  const handleTabChange = (event, newValue) => {
    setTabValue(newValue);
  };

  // 💡 [예외 유저 배열 선언] 해당 부서라도 예외적으로 전체 탭을 허용할 유저 UUID 목록
  const ALLOWED_DASHBOARD_USERS = [
    'e3e1a566-0e65-11ec-b577-f220cd7628ac', // admin
    '9A64EA44-3348-4144-B796-6C6537581E65' 
  ];

  // 💡 [부서 제어 및 예외 판별] 지정된 부서이면서 동시에 예외 유저 리스트에 포함되지 않는 경우에만 제한을 겁니다.
  const isTargetDepartment = user.dptInf?.parentDptUuid  === 'D6D83465-EDF3-450D-ADEB-906BDD9FD086';
  
  const isExceptedUser = ALLOWED_DASHBOARD_USERS.includes(user?.usrUuid);
  
  // 최종적으로 제한된 탭 구성을 보여줄지 여부 결정 (특정 부서이지만 예외 유저가 아닐 때만 true)
  const shouldRestrict = isTargetDepartment && !isExceptedUser;

  // 💡 1번 케이스: 기본 탭 구성 (전체 노출 - 일반 부서 직원 및 예외 허가된 마스터 어드민용)
  const defaultTabConfigs = [
    {
      id: 'tab-sales',
      label: '영업활동일정',
      component: <SalesActivityContainer toggleCalFull={toggleCalFull} isCalFull={isCalFull} />
    },
//    {
//      id: 'tab-tech',
//      label: '기술활동일정',
//      component: <TechActivityContainer toggleCalFull={toggleCalFull} isCalFull={isCalFull} />
//    },
    {
      id: 'tab-approval',
      label: '결재함',
      component: (
        <DetailTemplate title="내 결재함">
          <DashboardApprovalContainer />
        </DetailTemplate>
      )
    },
    {
      id: 'tab-notice',
      label: '공지사항',
      component: (
        <DetailTemplate title="공지사항">
          <NoticeTemplate />
        </DetailTemplate>
      )
    },
  ];

  // 💡 2번 케이스: 제한된 탭 구성 (기술활동일정이 숨겨진 형태 - 예외 대상을 제외한 특정 부서 직원용)
  const restrictedTabConfigs = [
    {
      id: 'tab-tech',
      label: '기술활동일정',
      component: <TechActivityContainer toggleCalFull={toggleCalFull} isCalFull={isCalFull} />
    },

  ];

  // 💡 상단 필터 조건식 결과에 따라 최종 배열 선택
  const visibleTabs = shouldRestrict ? restrictedTabConfigs : defaultTabConfigs;
    
  return calFullTyp ? (
    <DashboardTemplate user={user}>
      <DetailTemplate title="스케줄 관리">
        <DashboardCalendarContainer toggleCalFull={toggleCalFull} full />
      </DetailTemplate>
    </DashboardTemplate>
  ) : (
    <DashboardTemplate user={user}>
      {/* 💡 상단 탭 메뉴 구성 */}
      <Box sx={{ borderBottom: 1, borderColor: 'divider', mt: -3}}>
        <Tabs value={tabValue} onChange={handleTabChange} aria-label="dashboard tabs">
          {visibleTabs.map((tab, index) => (
            <Tab 
              key={tab.id}
              label={tab.label} 
              id={`dashboard-tab-${index}`} 
              aria-controls={`dashboard-tabpanel-${index}`} 
            />
          ))}
        </Tabs>
      </Box>

      {/* 💡 조건별로 선택된 탭 콘텐츠 바인딩 */}
      {visibleTabs.map((tab, index) => (
        <CustomTabPanel key={tab.id} value={tabValue} index={index}>
          {tab.component}
        </CustomTabPanel>
      ))}

      {/* <DetailTemplate title="결재선 관리">
        <Box sx={{ display: 'flex', justifyContent: 'flex-end', alignItems: 'center', my: 1 }}>
          <Button variant="outlined" onClick={handleAppLineToggle}>결제선 {appLineToggle ? `추가 닫기` : `추가`}</Button>
        </Box>
        <ApprovalListContainer />
        {appLineToggle && (
          <ApprovalFormContainer />
        )}
      </DetailTemplate>
      <DetailTemplate title="프로젝트 리스트">
        <ProjectListContainer pageUrl={projectPageUrl} />
      </DetailTemplate>
      <DetailTemplate title="유지보수 리스트">
        <MaintanceListContainer pageUrl={maintancePageUrl} />
      </DetailTemplate>
      <DetailTemplate title="세금계산서 리스트">
        <TaxbillListContainer />
      </DetailTemplate> */}
      {/* <DetailTemplate title="스케줄 확인">
      <DashboardCalendarContainer />
    </DetailTemplate> */}
    </DashboardTemplate>
  );
};

export default DashboardContainer;
